
<template>
  <section class="ATInsruction">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-row :gutter="12">
        <el-col :span="6">
          <el-form-item :label="`${$t('device.gateway_name')}:`">
            <span>{{ $route.query.name }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('integration.mac_address_c')">
            <span>{{ $route.query.mac }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('integration.carrier_c')">
            <span>{{ $route.query.carrierName || '--' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="16">
          <el-form-item :label="$t('integration.at_instruction_c')" prop="atinstruction">
            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 12 }" :placeholder="$t('integration.please_enter_at_command')"
              v-model="ruleForm.atinstruction" width="300px" @focus="focusFn" @keyup.enter.native="sendFn"></el-input>
          </el-form-item>
        </el-col>
        <el-button type="primary" @click="sendFn">{{$t('integration.send_out')}}</el-button>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="16">
          <el-form-item :label="$t('integration.console_c')" prop="console">
            <div class="consoleT">
              <!-- 内容 -->
              <section>
                <p>{{ contentArr[contentArr.length - 1] }}</p>
                <!-- <p v-for="(item, idx) in contentArr" :key="idx">
                  <span :class="idx === 0 ? 'red' : ''"></span>{{ item }}
                </p> -->
              </section>
              <section v-show="isShow">
                <h1>{{$t('integration.log_content_c')}}</h1>
                <p class="list-style" v-for="(opt, index) in hundredArr" :key="index">{{ opt }}</p>
              </section>
            </div>
          </el-form-item>
        </el-col>
        <el-button type="primary" @click="clearFn">{{$t('integration.eliminate')}}</el-button>
        <el-button type="primary" @click="consoleFn">{{$t('integration.journal')}}</el-button>
      </el-row>
    </el-form>
  </section>
</template>

<script>
//  gatewayGetAT,
// import { gatewaysendAT } from '@/api/api';

import { gatewayGetAT,gatewaySendAT } from '@/api/modules/at.js';

/**清除换行 */
const replaceTextarea1 = function (str) {
  var reg = new RegExp('\r\n', 'g')
  var reg1 = new RegExp('\n', 'g')

  str = str.replace(reg, '')
  str = str.replace(reg1, '')

  return str
}
export default {
  data() {
    return {
      ruleForm: {
        atinstruction: null,
      },
      rules: {
        atinstruction: [
          {
            required: true,
            message: $t('integration.at_instruction_cannot_be_empty'),
            trigger: 'blur',
          },
        ],
      },
      isShow: false,
      contentArr: [],
      timer: null,
      hundredArr: [],
    }
  },
  computed: {
    ATVal() {
      return JSON.parse(localStorage.getItem('ATs'))
    },
  },
  created() {
    this.httpFn()
    this.timer = setInterval(() => this.httpFn(), 2000)
  },
  mounted() { },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    httpFn() {
      gatewayGetAT({ mac: this.$route.query.mac }).then((res) => {
        if (res.state.code === 200) {
          this.contentArr = res.result.map((item) => {
            return `${item.timestamp + item.type + ':' + item.cmdContent}`
          })
          /** 指令发送成功进行一次存储指令 且只能存一百条*/
          this.$store.state.AT = res.result.slice(0, 100)
          this.hundredArr = this.$store.state.AT.map(item => {
            return `${item.timestamp + item.type + ':' + item.cmdContent}`
          });
        } else {
          this.$message.error(res.state.msg)
        }
      })
    },
    sendFn() {
      this.$refs.ruleForm.validate((vail) => {
        if (vail) {
          let array = replaceTextarea1(this.ruleForm.atinstruction)
            .split(';')
            .filter((item) => {
              return item
            })
          gatewaySendAT({
            mac: this.$route.query.mac,
            atCMDContent: array.join(';'),
          }).then((res) => {
            if (res.state.code === 200) {
              if (res.result === -1) {
                return this.$message.error(
                  this.$t('messageTitle.SystemException')
                )
              } else if (res.result === 200) {
                /**发送按钮继续开启定时 */
                this.timer = setInterval(() => this.httpFn(), 2000)

                return this.$message.success(this.$t('text.SentSuccessfully'))
              }
            } else {
              return this.$message.error(res.state.msg)
            }
          })
        }
      })
    },
    /*获取焦点时候将定时器暂停*/
    focusFn() {
      clearInterval(this.timer)
      this.timer = null
    },
    clearFn() {
      this.contentArr = []
      clearInterval(this.timer)
      this.timer = null
    },
    consoleFn() {
      this.isShow = !this.isShow
    },
  },
}
</script>

<style lang='scss' scoped>
.ATInsruction {
  padding: 100px;
  box-sizing: border-box;

  .consoleT {
    margin: 0;
    padding: 15px;
    box-sizing: border-box;
    width: 100%;
    max-height: 300px;
    min-height: 150px;
    border-radius: 15px;
    word-wrap: break-word;
    overflow: auto;
    border: 1px solid #d1d1d1;

    .red {
      color: red;
    }
  }

  /* 奇数行的样式 */
  .list-style:nth-child(odd) {
    color: #42df76;
  }

  /* 偶数行的样式 */
  .list-style:nth-child(even) {
    color: #f53030;
  }
}
</style>
